import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from 'layout/header';
import Footer from 'layout/footer';
import PageHeader from 'component/PageHeader';
import imgTop04 from '../../assets/images/img_top04.png';
import SolData from 'component/SolData';


const Solutions = () => {
    const { section } = useParams(); // URL 파라미터로 섹션 정보 가져오기
    const navigate = useNavigate();
    const [activeContent, setActiveContent] = useState('solution'); //기본 엑티브 컨텐츠츠
    const [pageTitle, setPageTitle] = useState("솔루션");

    useEffect(() => {
        if (!section) {
            // 잘못된 URL로 접근 시 제품소개로 리다이렉트
            navigate("/solutions/solution");
        } else {
            setActiveContent(section); // 섹션에 맞게 콘텐츠도 업데이트
        }
    }, [section, navigate]);

    // 드롭다운 메뉴 아이템 리스트
    const dropdownItems = [
        { key: "modelin", label: "ModelIN", path: "/solutions/modelin" },
        { key: "linkin", label: "LinkIN", path: "/solutions/linkin" },
        { key: "openin", label: "OpenIN", path: "/solutions/openin" },
        { key: "collectin", label: "CollectIN", path: "/solutions/collectin" },
    ];

    const breadcrumb = [
        { label: "홈", path: "/main" },
        { label: "솔루션" },
        {
            label: "제품소개",
            dropdown: dropdownItems.map(({ key, label, path }) => ({
                label,
                key,
                onClick: () => navigate(path),
            })),
        },
    ];

    const solItems = [
        { solNameEng: 'ModelIN', solNameKo: "통합 인터페이스 관리 시스템", data: "다양한 연계 시스템의 인터페이스 정보를 통합 관리하세요. 인터페이스 정보 및 IO 정보를 빠르게 공유 할 수 있습니다.", tag01: "#EIMS", tag02: "#Interface", tag03: "#GS인증" },
        { solNameEng: 'LinkIN', solNameKo: "통합 업무 연계 시스템", data: "다양한 프로토콜, 메시지 타입, 인터페이스 등 연계 정보를 업무 시스템에 맞춰 개발 가능하게 API를 지원합니다.", tag01: "#Gateway", tag02: "#QoS", tag03: "#GS인증" },
        { solNameEng: 'OpenIN', solNameKo: "오픈 API 포탈·관리 시스템", data: "다양한 API 개발 표준화를 하여 Doc, Test Bed 등을 제공하고 관리 합니다.", tag01: "#OPEN API", tag02: "#DOC", tag03: "#TEST BED" },
        { solNameEng: 'CollectIN', solNameKo: "빅데이터 수집·적재 시스템", data: "대용량에 데이터를 수집하며 필요한 형태로 가공/적재 합니다.", tag01: "#BigData", tag02: "#수집", tag03: "#적재" },

    ];

    const handleDetailClick = (path) => {
        navigate(`/solutions/${path.toLowerCase()}`);
    };

    // // AOS 초기화 및 리프레시
    // useEffect(() => {
    //     AOS.init();
    // }, []);
    //   data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="500"

  return (
    <div id="wrap">
        <Header />
        <section className="section">

            {activeContent === 'solution' && (
                <div className="content solution">
                    <PageHeader
                        title={pageTitle}
                        backgroundImage={imgTop04}
                        breadcrumb={breadcrumb.map(item => {
                            return item;
                        })}
                    />
                    <div className="container">
                        <div className="card-box">
                            {solItems.map((item) => (
                                <div className="card">
                                    <div className="sol-info">
                                        <span className="name">{item.solNameEng}</span>
                                        <span className="txt">{item.solNameKo}</span>

                                        <p>{item.data}</p>
                                    </div>
                                   
                                    <ul className="tag-group">
                                        <li className="tag">{item.tag01}</li>
                                        <li className="tag">{item.tag02}</li>
                                        <li className="tag">{item.tag03}</li>
                                    </ul>

                                    <div className="btn-group">
                                        <button
                                            type="button"
                                            className="btn blue"
                                            onClick={() => handleDetailClick(item.solNameEng)}
                                        >자세히 보기</button>
                                        {/* <button type="button" className='btn blue'>제품 문의</button> */}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="btn-group">
                        <Link to="/contact" className='btn main'>문의하기</Link>
                    </div>   
                </div>
            )}

            <SolData activeContent={activeContent} solItems={solItems} />
        </section>
        <Footer />
    </div>
  );
};

export default Solutions;
